import { jwtDecode } from "jwt-decode";

export const isTokenExpired = (token: string): boolean => {
  const decodedToken = jwtDecode(token);
  return (decodedToken.exp ?? 1) * 1000 < Date.now();
};
